import PropTypes from 'prop-types';
import React from 'react';

import Station from '../../records/Station';
import t from '../../lib/I18n';


class SearchPath extends React.Component {
    static propTypes = {
        mapsHelper: PropTypes.object,
        origin: PropTypes.instanceOf(Station),
        destination: PropTypes.instanceOf(Station)
    };

    static defaultProps = {
        mapsHelper: null,
        origin: new Station(),
        destination: new Station()
    };

    render () {
        const { mapsHelper, origin, destination } = this.props;

        if (mapsHelper && mapsHelper.loaded) {

            if (origin.latitude) {
                let originEl = document.createElement('div');
                originEl.className = 'map__label';
                originEl.innerHTML = `${ t('global.start') }: <strong>${ origin.name }</strong>`;
                mapsHelper.newLabel(originEl, {
                    latitude: origin.latitude,
                    longitude: origin.longitude
                });
            }

            if (destination.latitude) {
                let destinationEl = document.createElement('div');
                destinationEl.className = 'map__label';
                destinationEl.innerHTML = `${ t('global.end') }: <strong>${ destination.name }</strong>`;
                mapsHelper.newLabel(destinationEl, {
                    latitude: destination.latitude,
                    longitude: destination.longitude
                });
            }

            if (origin.latitude && destination.latitude) {
                let path = [ origin.toJS(), destination.toJS() ];
                mapsHelper.dashedLine(path);
            }
        }

        return null;
    }

}

export default SearchPath;



// WEBPACK FOOTER //
// ./src/components/map/SearchPath.js